import {HttpErrorResponse, HttpHandlerFn, HttpInterceptorFn, HttpRequest} from '@angular/common/http';
import {inject} from '@angular/core';
import {catchError, exhaustMap} from 'rxjs/operators';
import {throwError} from 'rxjs';
import {DialogService} from '~shared/ng/services/dialog/dialog.service';
import {OtpAuthDialogComponent} from '~shared/ng/interceptors/dialog/otp-auth-dialog/otp-auth-dialog.component';

export const otpAuthInterceptor: HttpInterceptorFn = (req: HttpRequest<any>, next: HttpHandlerFn) => {
    const dialog = inject(DialogService);

    return next(req).pipe(catchError((errorResponse: Readonly<HttpErrorResponse>) => {
        if (errorResponse.error &&
            typeof errorResponse.error === 'object' &&
            'errors' in errorResponse.error &&
            errorResponse.error?.errors[0]?.error === 'required' &&
            (errorResponse.error?.errors[0]?.error_param === 'otp_auth_email' || errorResponse.error?.errors[0]?.error_param === 'otp_auth_password')
        ) {
            return dialog.create(OtpAuthDialogComponent).onClose$
                .pipe(
                    exhaustMap(result => {
                        if (!result) {
                            return throwError(() => errorResponse);
                        }

                        const duplicate = req.clone({body: {...req.body, otpAuthPassword: result.otpAuthPassword}});
                        return next(duplicate);
                    })
                );
        }
        return throwError(() => errorResponse);
    }));
};

